module.exports = __webpack_public_path__ + "static/media/apoorva.059d0b96.jpg";